import React, { ReactElement } from 'react'

import Alert from '../../../../../../../../1stlog-ui/src/components/Alert'
import { useSperrgutLimitation } from './useSperrgutLimitation'

type SperrgutLimitationProps = {
  coliFieldName: string
}

export const SperrgutLimitation = (
  props: SperrgutLimitationProps,
): ReactElement => {
  const { coliFieldName } = props

  const { sperrgutAlert, isLimitExceeded } = useSperrgutLimitation({
    coliFieldName,
  })

  if (!isLimitExceeded) {
    return <></>
  }

  return (
    <Alert className="mt-1" warning>
      <strong>{i18n.t('bulk_cargo_mandantory', 'Sperrgut Pflicht')}</strong>
      <br />
      {sperrgutAlert}
    </Alert>
  )
}
